import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { CoaParameter, CoaResponse, ProductCoasParameter } from 'src/app/models/coa-parameter';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { CoasParameterService } from 'src/app/services/coas-parameter.service';
import { CoasService } from 'src/app/services/coas.service';
import { ProductService } from 'src/app/services/product.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-coa-details',
  templateUrl: './coa-details.component.html',
  styleUrls: ['./coa-details.component.scss']
})
export class CoaDetailsComponent implements OnInit{
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  @Input() coaId: number = null;
  currentCoa: CoaResponse = null;
  loading = false;
  timeout = null;

  constructor(
    private vendorService: VendorService,
    private productService: ProductService,
    private coaService: CoasService,
    private coasParameterService: CoasParameterService,
    private toastrService: ToastrService
  ){}

  ngOnInit(): void {
    this.getCoa();
  }

  getCoa(){
    if (!this.coaId) {
      return;
    }
    this.loading = true;
    this.coaService.getCoasById(this.coaId).subscribe({
      next: (response: ResponseObject) => {
        this.currentCoa = response.data;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("No se obtivieron datos del coa", "Error");
        this.loading = false;
      }
    });
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(false);
  }

  closedDetailCoa() {
    this.closed.emit(false);
    this.showModal = false;
  }
}
